export const useCallbackReportSummaryColumns = () => {
  return [
    {
      field: 'accepted_by',
      headerName: 'Accepted By',
      flex: 1,
    },
    {
      field: 'callbacks_accepted',
      headerName: 'Callbacks Accepted',
      flex: 1,
    },
  ];
};

export default useCallbackReportSummaryColumns;
